import { Button, Dialog, Portal, Text } from '@chakra-ui/react';
import { useRef } from 'react';

interface SessionExpiredDialogProps {
    open: boolean;
    /** The app's re-login handoff (sign out + sign-in with a return path). */
    onLogIn: () => void;
}

/** Blocking alert over the still-rendered page: no close affordance — the
 * only way on is a fresh sign-in. */
export function SessionExpiredDialog({
    open,
    onLogIn,
}: SessionExpiredDialogProps) {
    const loginRef = useRef<HTMLButtonElement>(null);

    return (
        <Dialog.Root
            open={open}
            role='alertdialog'
            placement='center'
            size='sm'
            modal
            closeOnEscape={false}
            closeOnInteractOutside={false}
            initialFocusEl={() => loginRef.current}
        >
            <Portal>
                <Dialog.Backdrop />
                <Dialog.Positioner>
                    <Dialog.Content>
                        <Dialog.Header>
                            <Dialog.Title fontSize='xl'>
                                Your session has expired
                            </Dialog.Title>
                        </Dialog.Header>
                        <Dialog.Body>
                            <Text>
                                Please log in again to continue using the app.
                            </Text>
                        </Dialog.Body>
                        <Dialog.Footer>
                            <Button
                                ref={loginRef}
                                variant='brand'
                                onClick={onLogIn}
                            >
                                Log In
                            </Button>
                        </Dialog.Footer>
                    </Dialog.Content>
                </Dialog.Positioner>
            </Portal>
        </Dialog.Root>
    );
}
